import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import AlertOctagon from "@insite/mobius/Icons/AlertOctagon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getIsCreditHold } from "@store/Store/Data/Carts/CartsSelector";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { siteWidthStyles } from "@store/theme/common/mixins";
import Color from "color";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: StoreApplicationState) => ({
    isCreditHold: getIsCreditHold(state),
});

export interface StoreCreditOnHoldMessageStyles {
    container?: InjectableCss;
    wrapper?: InjectableCss;
    icon?: IconPresentationProps;
}

const styles = {
    container: {
        css: css`
            padding: 1em 0;
            font-size: 0.85em;
            background-color: ${props => Color(props.theme.colors.danger.main).lighten(0.75).hex()};
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            ${siteWidthStyles()}
        `,
    },
    icon: {
        size: 25,
        css: css`
            margin-right: 1em;
        `,
    },
};

const StoreCreditOnHoldMessage: React.FC<Props> = ({ isCreditHold }) => {
    if (!isCreditHold) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.wrapper}>
                <Icon {...styles.icon} color="danger" src={AlertOctagon} />
                {siteMessage("On_Credit_Hold_Message")}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export const storeCreditOnHoldMessageStyles = styles;
export default connect(mapStateToProps)(StoreCreditOnHoldMessage);
